// CUSTOM MASTER DATA MAPPING
export default {
  // Master Data Title
  masterData: {
    AUTOSHIP: 'auto_ship',
    SELF_PICK_UP: 'Self Pick-up',
    WITHOUT_SHIPPING: 'Without Shipping',
    DELIVERY: 'Delivery',
    CREDIT: 'Credit',
    PWPN: 'Pwp(n)',
    PWPF: 'Pwp(f)',
    FOC: 'Foc',
    RENTAL: 'Rental',
    AMP: 'Auto-maintenance',
    BA_UPGRADE: 'BA Upgrade',
    REPURCHASE: 'Repurchase',
    PRE_ORDER: 'Pre-order',
    VOID: 'Void',
    REJECTED: 'Rejected',
    CANCELED: 'Canceled',
    CANCELLED: 'Cancelled',
    COMPLETED: 'Completed',
    PENDING: 'Pending',
    PENDING_ONLINE: 'Pending-online',
    APPROVED: 'Approved',
    DECLINED: 'Declined',
    EMAIL: 'Email',
    PHONE: 'Phone',
    REGISTRATION: 'Registration',
    FORMATION: 'Formation',
    ADDRESS: 'Address',
    CREDIT_CARD_PHOTOCOPY: 'Credit Card Photocopy',
    INCOME_PROOF: 'Income Proof',
    APPLICATION_FORM: 'Application Form',
    PDF: 'Pdf',
    IMAGE: 'Image',
    RENTAL_PRE_SCREENING_IN_REVIEW: 'In Review',
    RENTAL_PRE_SCREENING_APPROVED: 'Approved',
    RENTAL_PRE_SCREENING_REJECTED: 'Rejected',
    RENTAL_PRE_SCREENING_PENDING: 'Pending',
    RENTAL_CREDIBILITY_APPROVED: 'Approved',
    RENTAL_CREDIBILITY_REJECTED: 'Rejected',
    RENTAL_CREDIBILITY_PENDING: 'Pending',
    PERCENTAGE: 'Percentage',
    EWALLET_PAYMENT_LIST_STATUS_FAILED: 'Failed',
    EWALLET_PAYMENT_LIST_STATUS_SUCCESS: 'Successful',
    EWALLET_PAYMENT_LIST_STATUS_PENDING: 'In Process',
    STOCKIST_CONSIGNMENT_ORDER_FILTER: 'stockist_consignment_order',
    EXCLUDE_FROM_SALES_FILTER: 'exclude_from_sales',
    ID: 'I D',
    REPORT_USER_TYPE_MEMBER: 'Member',
    REPORT_USER_TYPE_STOCKIST: 'Stockist',
    CANCELLATION_MODE_FULL: 'Full',
    CAMPAIGN_REDEMPTION_METHOD_BOTH: 'Both',
    BONUS_TYPE_BV: 'BV',
    BONUS_TYPE_CBP_POINTS: 'CBP Points',
    BONUS_TYPE_SV: 'SV',
    GENDER_MALE: 'Male',
    ETHNIC_GROUP_MALAY: 'Malay',
    MARITAL_STATUS_SINGLE: 'Single',
    PREFERRED_CONTACT_EMAIL: 'Email',
    REPORT_BONUS_STATEMENT_MONTHLY_TYPE_SUMMARY: 'summary',
    ESAC_PRODUCT_ENTITLEMENT: 'Esac Product Entitlement',
    ESAC_EXCEPTION_PRODUCT: 'Esac Exception Product',
    ITOKEN_PRODUCT_ENTITLEMENT: 'Itoken Product Entitlement',
    ITOKEN_TOKEN_PRODUCT_ENTITLEMENT: 'Itoken Token Product Entitlement',
    EWALLET_FUND_WITHDRAW: 'withdraw',
    OVERSEA_TOP_UP: 'oversea_top-up_(otp)',
  },
  // Master Key
  masterKey: {
    SALE_DELIVERY_METHOD: 'sale_delivery_method',
    SALE_TYPES: 'sale_types',
    AUTOSHIP: 'auto_ship',
    SALE_ORDER_STATUS: 'sale_order_status',
    YEARLY_REPORT_TYPE: 'yearly_report_type',
    STOCKIST_STATUS: 'stockist_status',
    STOCKIST_TYPE: 'stockist_type',
    SHIPPING_METHOD_INFO: 'shipping_method_info',
    PWP_FREE_ITEMS_PROMO_TYPES: 'promotion_free_items_promo_types',
    PWP_FREE_ITEMS_PROMO_MEMBER_TYPES: 'promotion_free_items_member_types',
    COUNTRY_CODE: 'country_code',
    VOUCHER_PERIOD: 'voucher_period',
    CONSIGNMENT_ORDER_STATUS: 'consignment_order_status',
    CONSIGNMENT_RETURN_STATUS: 'consignment_return_status',
    EWALLET_AMOUNT_TYPE: 'ewallet_amount_type',
    EWALLET_ADJUSTMENT_REASON: 'ewallet_adjustment_reasons',
    REJECTED_GIRO_APPROVAL_STATUS: 'rejected_giro_approval_status',
    MEMBER_STATUS: 'member_status',
    CAMPAIGN_REWARD_VALUE_MULTIPLIER: 'campaign_reward_value_multiplier',
    RENTAL: 'rental',
    MARRIED: 'Married',
    EPP_PAYMENT_APPROVAL_STATUS: 'epp_payment_approval_status',
    TERMINATED: 'Terminated',
    ZONE_TYPE: 'zone_type',
    TAX_VALUE_TYPE: 'tax_value_type',
    DELIVERY_CHARGE_VALUE_TYPE: 'delivery_charge_value_type',
    SALE_CANCELLATION_MODE: 'sale_cancellation_mode',
    SALE_CANCELLATION_REASON: 'sale_cancellation_reason',
    PRODUCT_ADDITIONAL_REQUIREMENTS: 'product_additional_requirements',
    RENTAL_INSTALLATION_TIME_SECTION: 'rental_installation_time_section',
    CARD_TYPE: 'card_type',
    CARD_COMPANY: 'card_company',
    RENTAL_CARD_STATUS: 'rental_card_status',
    RENTAL_FILE_TYPE: 'rental_document_type',
    FILE_TYPE: 'file_type',
    RENTAL_PRE_SCREENING_STATUS: 'rental_pre_screen_status',
    RENTAL_CREDIBILITY_STATUS: 'rental_credibility_status',
    ADDRESSES_COMPULSORY_INDICES: 'addresses_compulsory_indices',
    EWALLET_GIRO_PAYMENT_LIST_STATUS: 'ewallet_giro_payment_status',
    PRODUCT_AND_KITTING_FILTRES: 'product_and_kitting_filters',
    CV_CONFIG: 'cv_config',
    IC_PASSPORT_TYPE: 'ic_passport_type',
    REPORT_USER_TYPE: 'report_user_type',
    TAIWAN_PURCHASE_REPORT_TYPE: 'taiwan_purchase_report_type',
    SMART_LIBRARY_EFORM_UPLOAD_FILE_TYPE: 'smart_library_eform_upload_file_type',
    CV_ALLOCATION_TYPE: 'cv_allocation_report_type',
    AGE_FOR_ENROLLMENT: 'age_for_enrollment',
    ISP_SUBSCRIPTION: 'isp_subscriptions',
    RECEIPT_MANAGEMENT_ACTIONS: 'receipt_management_actions',
    DATE_FORMATS: 'date_formats',
    RECEIPT_OPERATIONS: 'receipt_operations',
    DEPARTMENTS: 'departments',
    BONUS_TYPE: 'bonus_type',
    ITOKEN_REDEMPTION_METHOD: 'itoken_redemption_method',
    STATUS: 'status',
    CAMPAIGN_REDEMPTION_METHOD: 'itoken_redemption_method',
    GENDER: 'gender',
    RELATIONSHIPS: 'relationships',
    MARITAL_STATUS: 'martial_status',
    RELIGION: 'religion',
    ETHNIC_GROUP: 'ethnic_group',
    SALUTATION: 'salutation',
    OCCUPATION: 'occupation',
    EDUCATION: 'education',
    INDUSTRY: 'industry',
    SALARY_RANGE: 'salary_range',
    ANNUAL_REVENUE: 'annual_revenue',
    PREFERRED_CONTACT: 'preferred_contact',
    REPORT_BONUS_STATEMENT_MONTHLY_TYPE: 'report_bonus_statement_monthly_type',
    GENERAL_REPORT_CANCELLATION_REASON: 'receipt_cancellation_reason',
    PRODUCT_TEMPLATE_TYPE: 'product_template_type',
    EWALLET_TRANSACTION_TYPE: 'ewallet_transaction_type',
    PWP_RANGE_TYPE: 'pwp_range_type',
    GEMS_COUNTRY: 'gems_country',
    ENROLMENT_CONTRACT: 'enrolment_contract_submission_branch_address',
  },
  eppPaymentProviderType: {
    epp_moto: 'EPP (Moto)',
  },
  enrollmentMemberType: {
    BA: 'BA',
    MEMBER: 'Member',
    PREMIER_MEMBER: 'Premier Member',
  },
  // Common
  common: {
    STOCKIST_STAFF: 'Stockist_staff',
    STOCKIST: 'Stockist',
    ROOT: 'root',
  },
  scopeCountryKeys: {
    VIETNAM: 'vn',
    MALAYSIA: 'my',
  },
}
